import React from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

import 'react-toastify/dist/ReactToastify.css';
import SmsAdminSettingForm from 'src/sections/smsAdminSetting/SmsAdminSettingForm';

const MainSection = styled('div')(({ theme }) => ({
  padding: '64px 24px 14px 90px',
  [theme.breakpoints.down('sm')]: {
    padding: '56px 14px 14px 14px',
  },
}));

const HeadingSection = styled('div')(() => ({
  width: '100%',
  padding: '20px 0px 20px 0px',
  justifyContent: 'space-between',
}));

const ListAndDetailsSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const SmsAdminSetting = () => {
  return (
    <>
      <Helmet>
        <title>SMS Admin Setting | SA Panel</title>
      </Helmet>
      <MainSection>
        <HeadingSection />
        <Card>
          <ListAndDetailsSection>
            <SmsAdminSettingForm />
          </ListAndDetailsSection>
        </Card>
      </MainSection>
    </>
  );
};

export default SmsAdminSetting;
